import { render, staticRenderFns } from "./areaList.pug?vue&type=template&id=01d3657a&scoped=true&lang=pug&"
import script from "./areaList.ts?vue&type=script&lang=ts&"
export * from "./areaList.ts?vue&type=script&lang=ts&"
import style0 from "./areaList.scss?vue&type=style&index=0&id=01d3657a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d3657a",
  null
  
)

export default component.exports